import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ReleaseNote = props => {

    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const userid = query.get('id')

    useEffect(() => {
        document.title = "KKAP Lite  #リリースノート";
    });

    return (
        <div style={{ paddingLeft: 30, paddingTop: 30, height: '100vh', overflow: 'auto'  }}>
            <div style={{ marginBottom: 10, fontSize: 20 }} ><h3>KKAP Lite _v1 &emsp;リリースノート</h3></div>

            <h3 style={{ marginTop: 30 }}>【 version 2.1.2 &emsp; &emsp; -2026/8/27- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        検索リストの対応によりデグレ。（カスタムユーザー専用に変更）
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼入力（サンプル入力）</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                検索リストの条件を入れた場合初期表示しない改修を無効化する為パターン№検索の検索条件を削除
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 2.1.1 &emsp; &emsp; -2026/8/15- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        検索リストをDistinct固定にした事によるデグレ（カスタムユーザー専用に変更）
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>SMaterisl　- 附属マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「C/#」は「カラー」をTEXT（マスタ参照なし）に変更
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 2.1.0 &emsp; &emsp; -2026/7/25- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        「名前をつけて保存」「保存データを開く」を無効にする設定を追加（s_app_ctl 'STORAGE'）
                    </li>
                    <li>
                        「My項目登録」コマンドをレイアウト定義により自動判定し表示/非表示を行う
                    </li>
                    <li>
                        ENTRYで起動時レイアウトを指定した場合AGGridの列幅を保存したサイズで初期表示する
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼入力（サンプル入力）</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「確定」し登録した場合「パターン」「縫製指示」「附属明細」に「未確定」のものが存在した場合エラーとする。（ストアド実装）
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Spec　- 縫製仕様入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「未確定」にし登録した場合使用している加工依頼No（サンプルNo）が確定済のデータが存在した場合エラーとする。（ストアド実装）
                            </li>
                            <li>
                                画像が小さく出力される不具合を改修
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Pattern　- パターン寸法入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「未確定」にし登録した場合使用している加工依頼No（サンプルNo）が確定済のデータが存在した場合エラーとする。（ストアド実装）
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Colurway　- </p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「未確定」にし登録した場合使用している加工依頼No（サンプルNo）が確定済のデータが存在した場合エラーとする。（ストアド実装）
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Label　- 製品下げ札入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                <div>「付記用語」は「コード」「カラー明細」「付記用語」の順にセルを配置。</div>
                                <div>「付記用語明細書」のカラーを削除し「ネーム下げ札発注書」の付記用語欄に記載。</div>
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 2.0.0 &emsp; &emsp; -2026/5/6- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        フレームワークを.NET 5.0 →10.0に変更
                    </li>
                    <li>
                        <div>AGGridバージョンアップ</div>
                        <div>LISTに行番号を追加</div>
                        <div>切り取り、コピー、貼り付け機能拡充</div>
                    </li>
                    <li>
                        <div>Formsコントローラーを追加。親子関係がある任意テーブルのアクセス（Insert/Update/Delete）を可能とする</div>
                        <div>s_tblを追加。テーブル情報を持たせる</div>
                    </li>
                    <li>
                        Basesコントローラーで単一任意テーブルのアクセス（Insert/Update/Delete）を可能とする。s_tblを使用
                    </li>
                    <li>
                        データ種別がMASTER系において任意テーブルを取り扱えるようにする
                    </li>
                    <li>
                        LISTの検索有無をs_layoutから自動判定する（検索条件対象項目の有無による判定）
                    </li>
                    <li>
                        レイアウト設定でヘッダ出力項目の設定を可能とする（s_lo_headerfix）
                    </li>
                    <li>
                        データ種別に「16:RADIO(ラジオボタン)」を追加。Formのみ対応。Gridは「SELECT」扱い
                    </li>
                    <li>
                        更新不可のセルでステータスがENTRYFORMの場合検索リストを起動する機能が無効にならない不具合を改修
                    </li>
                    <li>
                        <div>貼り付け時自動で行追加しコピーした内容を完全に復元可能とする（表示行を超える場合でも切り捨てられない）</div>
                        <div>これにより行追加の行数の選択肢を変更</div>
                    </li>
                    <li>
                        AGGridの初期表示および最大行数設定機能を追加（s_logp_maxrow, s_logp_initrow）
                    </li>
                    <li>
                        AGGridの「行追加」に50行を追加
                    </li>
                </ul>
                <p style={{ marginTop: 5 }}>メニュ</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        別タブメニュ起動で同じメニュでも起動可能にする
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>全般</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「CHECKBOX」で作成していた項目を「RADIO」に変更
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Product  - 加工依頼入力　サンプル入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「納品カバー」名称入力欄を削除
                            </li>
                            <li>
                                「パターン寸法入力」で「確定」でないデータも連携可能とする
                            </li>
                            <li>
                                加工依頼入力の場合生地情報欄に「全巾」「有効巾」を追加し生地素材マスタの内容を表示
                            </li>
                            <li>
                                サンプルの場合「主アイテム」「サブアイテム」を変更可能とする
                            </li>
                            <li>
                                サンプルの場合「生地素材品番」「生地素材名」をフリー入力可能とする
                            </li>
                            <li>
                                リストのタブに「連携データ」「コスト」を追加
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Spec  - 縫製仕様入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「縫製仕様」「縫製ステッチ」「附属」の各明細数を加工依頼書の行数で固定する
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>附属明細入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                用尺の精度を小数第3位→2位に変更
                            </li>
                            <li>
                                用尺A～Dの説明欄を追加し検索リストに表示する
                            </li>
                            <li>
                                <div>「附属明細書」印刷機能を追加。A～Dを別シートで出力 </div>
                                <div>用尺0が対象外によりデータ出力がない場合はエラーを出力</div>
                            </li>
                            <li>
                                附属マスタ選択時「摘要」に「品名」、「単価」「外貨単価」にマスタ値をセットする
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Label　- 製品下げ札入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                リスト（VIEW）に「サンプル回数」を追加　※種別がサンプルに限る
                            </li>
                            <li>
                                附属マスタ選択時「副資材名称」に「品名」、「単価」「外貨単価」にマスタ値をセットする
                            </li>
                            <li>
                                付記用語に「C/＃」を追加。チェックされたカラーを付記用語明細表に出力する
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>SMaterial　- 画像/資料マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「コード」の桁数を3→5桁に変更
                            </li>
                            <li>
                                「区分」を削除
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>SMaterial　- 附属マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                <div>コード体型を「附属種別」-自動連番5桁に変更</div>
                                <div>これに伴い「附属種別」を必須にしMASTERREF→MASTERに変更</div>
                            </li>
                            <li>
                                「品名」を追加。附属明細の「摘要」製品下げ札入力の「副資材名称」に反映
                            </li>
                            <li>
                                「紳士婦人区分」を追加
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Material　- 生地素材マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                項目名を「区分」→「紳士婦人区分」に変更
                            </li>
                            <li>
                                原産国マスタをMASTERに変更。（データクリア）
                            </li>
                            <li>
                                「品番」を数字6桁以外で入力した場合登録時エラー
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Client　- 工場マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                原産国マスタをMASTERに変更。（データクリア）
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Code:country　- 原産国マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                コードを2→5桁に変更
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Code:cl_matl　- 紳士婦人区分（旧生地素材区分）</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                名称を「生地素材区分」→「紳士婦人区分」に変更
                            </li>
                            <li>
                                メニュカテゴリを「生地素材」→「マスタ」へ移動
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>加工依頼書</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                各画像の右下にファイル名を出力
                            </li>
                            <li>
                                ネーム下げ札発注書に「SDGｓ印字」欄を追加。生地素材マスタのSDGｓを出力
                            </li>
                            <li>
                                付記用語明細書に「附属カラー」欄を追加。付記用語明細のチェックしたC/#を出力する
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 1.5.1 &emsp; &emsp; -2026/3/3- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        <div>基本項目フォーマットの機能追加</div>
                        <div>項目名フィールドの列幅を100→95に変更。項目名が16バイトを超えた場合フォントサイズを小さくする</div>
                        <div>フィールドサイズを1/8、1/5、2/5、3/5、4/5を指定可能とする</div>
                        <div>レスポンシブ対応の調整</div>
                    </li>
                    <li>
                        <div>FORMセクションの基本項目Type=100にフォトギャラリを表示する機能を追加（s_app_ctl 'GALLERY'）</div>
                        <div>※サムネイル化は未実装</div>
                    </li>
                </ul>
            </div>

            <h3 style={{ marginTop: 30 }}>【 version 1.5.0 &emsp; &emsp; -2026/2/21- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        FORMセクションのX（閉じる）コマンドを無効にする設定を追加（s_app_ctl 'SELCLOSE'）
                    </li>
                    <li>
                        Menuを開く度にダッシュボードが立ち上がる。ログイン時のみ起動されるよう改修
                    </li>
                    <li>
                        FORM画面を起動した際先頭項目にフォーカスをあてる
                    </li>
                    <li>
                        <div>ログ出力整備</div>
                        <div>DBアクセスに対するSQLを全出力する。SQL_yyyy-mm-dd.log</div>
                        <div>エラーログに本システム外のエラーを出力しないように変更。ログファイル名をERR_yyyy-mm-dd.logに変更</div>
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>全般</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                セクションの「X」閉じるボタンを無効にする
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Label　- 製品下げ札入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                <div>「付記用語明細書」の行の高さを付記用語に合わせて調整する。</div>
                                <div>文章の折り返しには対応できない為付記用語マスタにて改行を挿入する事により調整いただく</div>
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 1.4.0 &emsp; &emsp; -2026/2/8- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        NEWFORMおよびCOPYFORMで関連ファイルのセットを可能とする
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        <div>ヘッダ部デザインおよびUIを変更</div>
                        <div>FORM画面の場合メニュタイトル右側に表示中の（主に）キー情報を表示。※スクロールした場合でもキー情報がわかるようにする為</div>
                        <div>FORM画面の上、左右の余白およびヘッダの高さを小さくし内容を表示するエリアを広げる</div>
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        Triggerでセットされる項目が計算式内にあった場合計算実行されるよう対応
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        レイアウトグループのid=0の場合の処理を共通化（EntryBase）
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼入力、サンプル入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                年度と品番の整合チェックを追加（エラーまたはワーニングを出力）
                            </li>
                            <li>
                                「サイズ」セクションに「サイズ初期値セット」コマンドを追加。パターンNoが持つサイズをセットする
                            </li>
                            <li>
                                「パターン寸法表」シートのサイズが最大枠を超えた場合別シートに出力
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Pattern　- パターン寸法入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「パターンNo」の文字制約を「英数記号のみ」→「半角のみ」に変更
                            </li>
                            <li>
                                基準値が数値でない場合計算実行で0になってしまう。そのままの値をセット
                            </li>
                            <li>
                                「パターン寸法表」の印刷を可能とする
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Colourway　- 付属明細入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                附属コード入力時附属マスタの「単価」「外貨単価」をセットする
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Label　- 製品下げ札入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「パーツ名①②」を「品質表示①②」に文言変更
                            </li>
                            <li>
                                洗濯表示の「洗い方」を1にした時「塩素」=1「タンブル」=1「干し方」=0を初期セット
                            </li>
                            <li>
                                洗濯表示の「干し方」が0の時「洗い方」が1以外の場合エラー　※すべて0の場合は除外
                            </li>
                            <li>
                                混率チェックを追加
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>SMaterial　- 附属マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「単価」「外貨単価」項目追加
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 1.3.0 &emsp; &emsp; -2026/1/12- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>USER UPDATE ONLY</p>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼入力、サンプル入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「付属明細No」「タイプ(A～D)」を追加し付属明細入力と連携する
                            </li>
                            <li>
                                加工依頼書の附属仕様書の配色欄を「色番」→「色番」＋「色名」に変更
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Spec　- 縫製仕様入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                縫製仕様書出力時に仕様詳細図が出力されない不具合を改修
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Clourway　- 付属明細入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「製品附属No」→「附属明細No」に変更。自動採番→任意入力に変更
                            </li>
                            <li>
                                「種別」「No」「製品品番」「製品名」「通貨」削除
                            </li>
                            <li>
                                「ブランド」を入力項目に変更
                            </li>
                            <li>
                                「アイテム」項目を追加　※サブアイテム参照
                            </li>
                            <li>
                                加工依頼No（サンプルNo）との紐づけをなくしたことにより「カラー明細」「サイズ明細」を追加
                            </li>
                            <li>
                                <div>「生地素材コード」「生地素材品番」「生地素材名」項目を追加</div>
                                <div>「生地素材コード」入力時マスタのカラー明細を表示する</div>
                            </li>
                            <li>
                                <div>共通用尺を１枠から４枠（A～D）に変更。これに伴い「金額」「外貨金額」も４枠に変更</div>
                                <div>合計欄を４行にしA～Dに対する内容を表示する</div>
                                <div>「用尺表示切替」「金額表示切替」を追加。用尺および金額項目の表示/非表示の切替を可能とする</div>
                            </li>
                            <li>
                                「組成」項目を追加。チェックした附属の組成を「製品下げ札入力」で初期表示するため。
                            </li>
                            <li>
                                附属仕様書の出力機能を削除                 
                            </li>
                        </ul>
                    </div>
                    <p style={{ marginTop: 5 }}>Label　- 製品下げ札入力</p>
                    <ul style={{ marginTop: 5, marginLeft: 30 }}>
                        <li>
                            加工依頼No（サンプルNo）入力時付属明細から該当する組成を品質表示②にセットする（NEWFORM,COPYFORMのみ）
                        </li>
                    </ul>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 1.2.1 &emsp; &emsp; -2026/1/6- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>USER UPDATE ONLY</p>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼入力、サンプル入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                <div>加工依頼書（サンプル依頼書）出力時にエラーが発生する不具合を改修</div>
                                <div>「縫製仕様入力」の連携方法変更に伴う対応漏れ</div>
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Spec　- 縫製仕様入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                <div>縫製仕様書出力時にエラーが発生する不具合を改修</div>
                                <div>「縫製仕様入力」の連携方法変更に伴う対応漏れ</div>
                            </li>
                        </ul>
                    </div>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Material　- 生地素材マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                入力中データがstoreRowData()にて正しく保存されていない事によりリフレッシュで無くなってしまう
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 1.2.0 &emsp; &emsp; -2026/1/4- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5 }}>Menu</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        編集項目が存在する場合確認メッセージでCancelした場合メニューを閉じた状態にする
                    </li>
                    <li>
                        別タブでメニュを起動した場合元画面のメニューを閉じた状態にする
                    </li>
                </ul>
                <p style={{ marginTop: 5 }}>SMaterial</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        組成の混率合計が0または100以外の場合エラーとする
                    </li>
                </ul>
                <p style={{ marginTop: 5 }}>全般</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        グリッドの「参照マスタ起動」を実行した場合ENTER FORMを有する画面はENTER FORM画面を起動する
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        親テーブルの項目をAGGridで複数入力可能とする　※レイアウトグループのID=plで指定　一部対応 Material等
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        「拡張ワーニングチェック処理」「拡張登録処理」機能を追加　※一部対応 Material等
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        グリッドに「最大化」⇔「元に戻す」機能を追加　※前回の状態が保持される　※一部対応 Spec等
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        初期値が設定されている場合必須チェックが無効になる不具合の改修
                    </li>
                </ul>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        Typeを使用したコントローラ画面の画像および関連ファイルの削除時エラーが発生する不具合の改修
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Menu</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「製品仕様入力」→「縫製仕様入力」にメニュ名を変更
                            </li>
                            <li>
                                「パターン入力」→「パターン寸法入力」にメニュ名を変更
                            </li>
                            <li>
                                「製品附属入力」→「付属明細入力」にメニュ名を変更
                            </li>
                            <li>
                                「*繊維」→「素材」にメニュ名を変更
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Pattern　- パターン寸法入力（旧 パターン入力）</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                サイズに「体型別パターンNo」を追加。１つの体型に対し１つのパターンNoの登録を可能とする
                            </li>
                            <li>
                                <div>グレーディングで２つ目以降の体型の基準値欄を体型グレーディングとし前の体型からの「差数」を入力とする</div>
                                <div>「先頭体型の基準値を続く体型の基準値にセットする」処理を削除</div>
                            </li>
                            <li>
                                「アイテム」を更新可能に変更
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Spec　- 縫製仕様入力（旧 製品仕様入力）</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「製品仕様No」を自動採番→任意入力に変更
                            </li>
                            <li>
                                「種別」「No」「製品品番」「製品名」「シーズン」「生地素材名」削除
                            </li>
                            <li>
                                「ブランド」を入力項目に変更
                            </li>
                            <li>
                                「アイテム」項目を追加　※サブアイテム参照
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼入力、サンプル入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「製品納品先」をマスタ選択に変更。サンプル入力の初期値はブランクにする
                            </li>
                            <li>
                                「加工賃」の精度を小数２桁に変更
                            </li>
                            <li>
                                「マージン」の精度を整数６＋小数２桁に変更。※率でなく実費を入力
                            </li>
                            <li>
                                「シーズン」を必須に変更
                            </li>
                            <li>
                                List及びFormに「製品買単価」項目を追加
                            </li>
                            <li>
                                Listに「仕入単価」項目を追加。加工依頼書の「仕入単価」と同一
                            </li>
                            <li>
                                <div>縫製仕様書、付属明細と連携するコードの入力フィールドを追加</div>
                                <div>これに伴いパターン№入力フィールド位置変更</div>
                            </li>
                            <li>
                                「パターン№」選択リストに「体型別パターン№」を追加
                            </li>
                            <li>
                                <div>カラー明細の初期値として生地素材マスタのカラー明細を表示する（加工依頼入力のみ　サンプルは初期値なし）</div>
                                <div>サンプルNo入力時または生地明細入力時（カラー明細未入力時）</div>
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼書印刷</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「設計寸法表」→「パターン寸法表」に変更
                            </li>
                            <li>
                                「附属仕様書」→「付属明細書」に変更
                            </li>
                            <li>
                                「製品買単価」が0でない場合「仕入単価」の項目名を「製品買単価」とし「製品買単価」を出力する
                            </li>
                            <li>
                                「パターンNo」欄の出力内容を「体型別パターン№」から取得する
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Label　- 製品下げ札入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                               「SDG's」を追加。生地素材品番の「SDG's」を表示
                            </li>
                            <li>
                                組成の「繊維」→「素材」に項目名変更
                            </li>
                            <li>
                                組成の素材（旧繊維）をマスタ選択のみとし名称変更不可とする
                            </li>
                            <li>
                                組成の「混率」を整数にする
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Material　- 生地素材マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                「物性データ有無」のリスト内容を有/無に変更
                            </li>
                            <li>
                                「単価」→「単価（￥）」に項目名変更
                            </li>
                            <li>
                                「通貨」「外貨単価」の項目順を入れ替え
                            </li>
                            <li>
                                組成の「繊維」→「素材」に項目名変更
                            </li>
                            <li>
                                組成の素材（旧繊維）をマスタ選択のみとし名称変更不可とする
                            </li>
                            <li>
                                <div>組成の並び順が規則に反している場合ワーニングを出力する（そのまま登録可）</div>
                                <div>混率（降順）、優先順位（昇順）</div>
                            </li>
                            <li>
                                「機能性」「SDG's」を複数行入力可能とする
                            </li>
                            <li>
                                「年度」を数値４桁のみ有効に変更（制約を追加）
                            </li>
                            <li>
                                「シーズン」を必須に変更
                            </li>
                            <li>
                                カラー明細を「C/#」の昇順に自動登録する
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>SMaterial　- 附属マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                組成を追加
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Code:fiber　- 素材（旧繊維）</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                優先順位項目を追加　※ブランクの場合優先度：最低
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Code:delivery　- 納品先</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                新規追加
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Code:sdgs　- SDG's</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                新規追加
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{marginTop:30 }}>【 version 1.1.0 &emsp; &emsp; -2025/11/24- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p style={{ marginTop: 5}}>Menu</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        各画面からMenu起動した場合の表示サイズを全画面でなくし元画面エリアをクリックする事により復帰できるように変更
                    </li>
                </ul>
                <p style={{ marginTop: 5 }}>Product</p>
                <ul style={{ marginTop: 5, marginLeft:30 }}>
                    <li>
                        Entry FormでSKUマトリクス上の数量が歯抜けの場合合計欄にNaNが表示される
                    </li>
                </ul>
                <p style={{ marginTop: 5 }}>Label</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        Entry Formで絵表示の行が表示されなくなる場合がある
                    </li>
                </ul>
                <p style={{ marginTop: 5 }}>Material</p>
                <ul style={{ marginTop: 5, marginLeft: 30 }}>
                    <li>
                        組成が100％を超える場合アラートが表示されない
                    </li>
                </ul>
            </div>
            {!userid.includes('daidoh') ? null :
                <React.Fragment>
                    <p style={{ marginTop: 20, marginLeft: 5 }}>************** USER UPDATE ***************</p>
                    <div style={{ paddingTop: 5, paddingLeft: 20 }}>
                        <p style={{ marginTop: 5 }}>Product　- 加工依頼入力、サンプル入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                主アイテムを入力可能とし主アイテム選択後サブアイテムを選択できるようにする。＜定義変更＞
                            </li>
                            <li>
                                サンプル入力で削除時必ず参照済エラーが発生し削除できない。＜定義変更＞
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Label　- 製品下げ札入力</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                加工依頼NoまたはサンプルNo入力時生地素材マスタの混率を初期セットする。
                            </li>
                            <li>
                                「摘要」の登録内容が「ネーム下げ札発注書」に出力されない
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Material　- 生地素材マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                混率の小数桁を1→0に変更。＜定義変更＞
                            </li>
                            <li>
                                C/#をカラーマスタのコードのみ有効とする。＜定義変更＞
                            </li>
                            <li>
                                検査証明書項目を削除。＜定義変更＞
                            </li>
                            <li>
                                機能性をマスタ参照に変更。＜定義変更、マスタ追加＞
                            </li>
                            <li>
                                番手タテ、番手ヨコをNUMERIC→TEXTに変更。＜定義変更＞
                            </li>
                       </ul>
                        <p style={{ marginTop: 5 }}>SMaterial　- 附属マスタ</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                リスト項目に「規格」を追加＜定義変更＞
                            </li>
                        </ul>
                        <p style={{ marginTop: 5 }}>Code:function　- 機能性</p>
                        <ul style={{ marginTop: 5, marginLeft: 30 }}>
                            <li>
                                新規追加
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            }

            <h3 style={{ marginTop: 30 }}>【 version 1.0.1 &emsp; &emsp; -2025/08/27- 】</h3>
            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                <p>New リリース</p>
            </div>

            </div>
    );
};

